document.addEventListener('DOMContentLoaded', function() {
// Select the lines
const horizontalLine = document.querySelector(".mouse-line.horizontal");
const verticalLine = document.querySelector(".mouse-line.vertical");

// Function to add the "faded" class to both lines
function fadeLines() {
  horizontalLine.classList.add("faded");
  verticalLine.classList.add("faded");
}

// Function to remove the "faded" class from both lines
function unfadeLines() {
  horizontalLine.classList.remove("faded");
  verticalLine.classList.remove("faded");
}

// Mousemove event to update the line positions
document.addEventListener("mousemove", function(event) {
  // Update the position of the vertical and horizontal lines
  verticalLine.style.left = `${event.clientX}px`;
  horizontalLine.style.top = `${event.clientY}px`;
});

// Add event listeners to handle mouse over specific elements
document.querySelectorAll(".hover-target").forEach((element) => {
  element.addEventListener("mouseenter", fadeLines);  // Fade the lines on hover
  element.addEventListener("mouseleave", unfadeLines);  // Unfade the lines when leaving
});
});